import {AnalyticsApi, AuthenticateApi, Configuration, SiteApi, UserApi} from "../services";
import axios, {AxiosInstance} from "axios";
import config from "../config/config";

export const _baseURL = config.REACT_APP_API_BASE_URL;

export class Api {

    token: string;

    axiosInstance: AxiosInstance;

    siteApi: SiteApi;
    userApi: UserApi;
    analyticsApi: AnalyticsApi;
    authenticateApi: AuthenticateApi;

    constructor(token: string) {
        const config: Configuration = new Configuration();
        this.axiosInstance = axios.create({
            baseURL: _baseURL,
            headers: {
                Authorization: `Bearer ${token}`,
            },
        });

        this.token = token;
        this.siteApi = new SiteApi(config, '', this.axiosInstance);
        this.userApi = new UserApi(config, '', this.axiosInstance);
        this.analyticsApi = new AnalyticsApi(config, '', this.axiosInstance);
        this.authenticateApi = new AuthenticateApi(config, '', this.axiosInstance);
    }

    getAxiosInstance(): AxiosInstance {
        return this.axiosInstance;
    }

    hasToken(): boolean {
        return this.token !== null;
    }
}